__turbopack_context__.v({
  "contentContainer": "form-module-scss-module__9A_SyW__contentContainer",
  "form": "form-module-scss-module__9A_SyW__form",
  "formContainer": "form-module-scss-module__9A_SyW__formContainer",
  "formWrapper": "form-module-scss-module__9A_SyW__formWrapper",
  "iSucceeded": "form-module-scss-module__9A_SyW__iSucceeded",
});
